import * as Yup from 'yup';
import validator from 'validator';
import { useFormik } from 'formik';

import { EMAIL_INVALID, requiredMsg } from 'lib/constants/messages';

const PracticeContactInfoSchema = Yup.object().shape({
  practiceEmail: Yup.string().email(EMAIL_INVALID).required(requiredMsg('Email')),
  practicePhone: Yup.string().test('practicePhone', '', (value, validationContext) => {
    const { createError } = validationContext;

    if (value === undefined || value === null || value === '') {
      return true; // Phone is not required
    }
    if (!validator?.isMobilePhone(value)) {
      return createError({ message: 'Enter a valid phone number' });
    }

    return true;
  })
});

export default function usePracticeContactInfoFormik(contactInfo = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      practiceEmail: contactInfo?.email || '',
      practicePhone: contactInfo?.phone || '',
      twilioPhone: contactInfo?.twilio_phone || '',
      fax: contactInfo?.fax || ''
    },
    enableReinitialize: true,
    validationSchema: PracticeContactInfoSchema,
    onSubmit
  });

  return formik;
}
